import {fromJS, Record, Map} from "immutable";

import {
  SHOW_MODAL_WINDOW,
  REMOVE_MODAL_WINDOW,
  UPDATE_MODAL_WINDOW,
  SHOW_WINDOW,
  REMOVE_WINDOW,
  FOCUS_WINDOW
} from "../actions/WindowActions";

const WindowRecord = Record({
  id: "",
  kind: "",
  title: "",
  payload: Map(),
  options: Map()
})

const initialState = fromJS({
  windowIds: [],
  windows: {},
  modalIds: [],
  modals: {},
  modalActive: false
})

const reducer = function(state = initialState, action) {
  switch(action.type) {

    case SHOW_WINDOW:
      return addWindow(state, action.windowId, action.kind, action.payload, action.title);

    case REMOVE_WINDOW:
      return removeWindow(state, action.windowId);      

    case SHOW_MODAL_WINDOW:
      return addModalWindow(state, action.windowId, action.kind, action.payload, action.title, action.options);

    case REMOVE_MODAL_WINDOW:
      return removeModalWindow(state, action.windowId);

    case UPDATE_MODAL_WINDOW:
      return updateModalWindow(state, action.windowId, action.payload, action.title, action.options);

    case FOCUS_WINDOW:
      return focusWindow(state, action.windowId);

    default:
      return state;
  }
}

function addModalWindow(state, id, kind, payload, title, options) {
  let updatedState = state.setIn(["modals", id], new WindowRecord({id: id, kind: kind, payload: payload, title: title, options: options}));
  return updatedState.set("modalIds", updatedState.get("modalIds").push(id))
                     .set("modalActive", true);
}

function updateModalWindow(state, id, payload, title, options) {
  let oldState = state.getIn(["modals", id]);
  return state.setIn(["modals", id], new WindowRecord({id: id, kind: oldState.kind, payload: payload, title: title, options: options}));
}

function removeModalWindow(state, id) {
  let filteredModalIds = state.get("modalIds").filter(windowId => windowId !== id);
  return state.set("modalIds", filteredModalIds)
              .deleteIn(["modals", id])
              .set("modalActive", filteredModalIds.size > 0);
}

function addWindow(state, id, kind, payload, title) {
  let updatedState = state.setIn(["windows", id], new WindowRecord({id: id, kind: kind, payload: payload, title: title}));
  return updatedState.set("windowIds", updatedState.get("windowIds").push(id))
}

function removeWindow(state, id) {
  let filteredWindowIds = state.get("windowIds").filter(windowId => windowId !== id);
  return state.set("windowIds", filteredWindowIds)
              .deleteIn(["windows", id]);
}

function focusWindow(state, id) {
  if (state.get("windowIds").last(id) === id) return state;
  let newIds = state.get("windowIds").filter((value) => value !== id);
  return state.set("windowIds", newIds.push(id));
}


export function getModals(state) {
  return state.get("modalIds").map(id => {
    return state.getIn(["modals", id]);
  })
}

export function getWindows(state) {
  return state.get("windowIds").map(id => {
    return state.getIn(["windows", id]);
  })
}

export default reducer;